import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core'
import { provideRouter, withComponentInputBinding } from '@angular/router'
import { registerLocaleData } from '@angular/common'
import localeEs from '@angular/common/locales/es'

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http'
import { headersInterceptor, API_BASE_URL } from 'superlikers-microsites-api'
import { SETTINGS, SPANISH_ERROR_MESSAGES, VALIDATION_ERROR_MESSAGES } from 'superlikers-dynamic-forms'

import { environment } from '@environments/environment'
import { settings } from '@shared/utils'
import { routes } from './app.routes'

registerLocaleData(localeEs)

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([headersInterceptor])),
    {
      provide: API_BASE_URL,
      useValue: environment.baseUrl
    },
    {
      provide: VALIDATION_ERROR_MESSAGES,
      useFactory: () => SPANISH_ERROR_MESSAGES
    },
    {
      provide: SETTINGS,
      useValue: settings
    },
    {
      provide: LOCALE_ID,
      useValue: 'es'
    }
  ]
}
